import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Input } from '@angular/core';
import { AppService } from '../../../services/app.service';
import { NotificationService } from '../../../services/notification.service';
import { INotificationInboxListItem, INotificationInboxStatus, NotificationChannel } from '../../../models/Notification';

const cache: {
    [id: number]: INotificationInboxStatus[]
} = {};

interface IMessage {
    channels: { name: string, status: string }[];
    text: string;
}

@Component({
  selector: 'app-notification-inbox-view',
    templateUrl: './notification-inbox-view.component.html',
    styleUrls: ['./notification-inbox-view.component.scss']
})
export class NotificationInboxViewComponent {
    constructor(
        private app: AppService,
        private service: NotificationService,
        private activeModal: NgbActiveModal
    ) { }

    requests: INotificationInboxStatus[] = [];

    //messages: {
    //    channels: { name: string, status: string }[],
    //    text: string
    //}[] = [];



    private _item: INotificationInboxListItem;

    @Input() set item(item: INotificationInboxListItem) {
        this._item = item;
        this.fetch();
    }

    get item() {
        return this._item;
    }

    get isFullContentVisible() {
        return this.requests.some(t => t.Channel != NotificationChannel.Sms);
    }

    get isShortContentVisible() {
        return this.requests.some(t => t.Channel == NotificationChannel.Sms);
    }

    close() {
        this.activeModal.dismiss();
    }

    private fetch() {
        const id = this.item.Id;

        if (cache[id]) {
            this.requests = cache[id];
        } else {
            this.app.addLoading(this.service.getInboxStatus(id)).subscribe(data => {
                this.requests = data;

                //const sms = data.find(t => t.Channel == NotificationChannel.Sms);
                //const nonSms = data.filter(t => t.Channel != NotificationChannel.Sms);

                //if (sms) {
                //    this.messages.push({
                //        channels: [{
                //            name: NotificationChannel.Sms,
                //            status: sms.Status
                //        }],
                //        text: this.item.ShortMessage
                //    });
                //}

                //if (nonSms.length) {
                //    this.messages.push({
                //        channels: nonSms.map(t => {
                //            return {
                //                name: t.Channel,
                //                status: t.Status
                //            }
                //        }),
                //        text: this.item.Message
                //    });
                //}

                cache[id] = data;
            });
        }
    }
}
